import { store } from "../store/store";
import { setglobalData } from "../store/slices/globalData-slice";
import { setCurrency } from "../store/slices/currency-slice";
import { setProducts } from "../store/slices/product-slice";

const currencyMap = {
  usd: "$",
  eur: "€",
  gbp: "£",
  inr: "₹",
  jpy: "¥",
  cad: "C$",
  aud: "A$",
  nzd: "NZ$",
};

export const fetchGlobalData = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_HTTPS_URL}/businessinfo`,
      {
        method: "GET",
        headers: {
          "Client-Id": process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    const result = await response.json();    
    store.dispatch(setglobalData(result));
    const currencySymbol = currencyMap[result.currency.toLowerCase()] || result.currency;

    store.dispatch(setCurrency(currencySymbol));
    document.title = result.businessName;
    
    // Full image URL with cache busting
    const imageUrl = `${process.env.REACT_APP_IMAGE_URL}/${result.logoUrl}?v=${Date.now()}`;
    
    // Update favicon
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = imageUrl; // Update with full URL including cache busting
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.id = "favicon";
      newFavicon.href = imageUrl;
      document.head.appendChild(newFavicon);
    }
    
    // Update Open Graph meta tags for link previews
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.content = imageUrl;
    } else {
      const newOgImage = document.createElement("meta");
      newOgImage.setAttribute("property", "og:image");
      newOgImage.content = imageUrl;
      document.head.appendChild(newOgImage);
    }
    
    // Update Twitter Card meta tags
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) {
      twitterImage.content = imageUrl;
    } else {
      const newTwitterImage = document.createElement("meta");
      newTwitterImage.setAttribute("name", "twitter:image");
      newTwitterImage.content = imageUrl;
      document.head.appendChild(newTwitterImage);
    }
    
    // Update additional meta tags for better link previews
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.content = result.businessName;
    } else {
      const newOgTitle = document.createElement("meta");
      newOgTitle.setAttribute("property", "og:title");
      newOgTitle.content = result.businessName;
      document.head.appendChild(newOgTitle);
    }
    
    // Add description if available
    if (result.description) {
      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) {
        ogDesc.content = result.description;
      } else {
        const newOgDesc = document.createElement("meta");
        newOgDesc.setAttribute("property", "og:description");
        newOgDesc.content = result.description;
        document.head.appendChild(newOgDesc);
      }
    }

  } catch (error) {
    console.error("Error fetching business info:", error);
  }
};

export const fetchProducts = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_HTTPS_URL}/products?limit=400&page=1&status=1`,
      {
        method: "GET",
        headers: {
          "Client-Id": process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    const products = result.data;

    // Dispatch action to store the products in Redux
    store.dispatch(setProducts(products));
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};
